module.exports = __webpack_public_path__ + "static/media/piyush-goyal-03.8ddc99ae.jpg";